import { FC, ReactElement } from "react";
import { Stack } from "@mui/material";

import { NoData, PageHeader } from "@/components";

const Historical: FC = (): ReactElement => {
  return (
    <Stack direction="column" flex={1}>
      <PageHeader title="Historical Savings - Coming Soon!" />
      <NoData />
    </Stack>
  );
};

export default Historical;
